/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgQuoteFile = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2h2.125v2H5v-.1H4zm4.375 0h2.25v2h-2.25zm6.039 0h-1.539v2H13v.25h.836l.082.082L14 4.25h1v-1l.332-.332zm2.004 4.832-1.25-1.25 1.414-1.414 1.25 1.25zM4 5.7v1.8h2V5.7zm13.75 2.464-.082-.082L17.75 8V7h1l.332-.332.918.918v1.497h-2V9h-.25zM15 7v-.25h-2V9h2.25V7zm5 4.25v2.167h-2V11.25zm0 6.5v-2.167h-2v2.167zm0 2.167V22h-1.875v-1H18v-1.083zM11.747 22h1.128v-2h-.18a4.78 4.78 0 0 1-.948 2zm4.628 0h-1.75v-2h1.75zM5 11v1H4a3 3 0 1 0 0 6h1v2H2v2h3v1h2v-1h1a3 3 0 1 0 0-6H7v-2h3v-2H7v-1zm-1 3h1v2H4a1 1 0 1 1 0-2zm3 6v-2h1a1 1 0 1 1 0 2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgQuoteFile as QuoteFile };
